module.exports = __webpack_public_path__ + "media/tier-2-xxxmas-1279c915b46937732dc8413da3465b2a.mp3";